import { useState } from 'react'
import type { FormEvent } from 'react'
import { ApiError } from '../api/client'
import { submitVendorInquiry } from '../api/inquiries'
import {
  EMPTY_VENDOR_REGISTRATION,
  VENDOR_REGISTRATION_COPY,
  type UseInquiryFormResult,
  type VendorRegistrationForm,
} from '../constants/inquiries'
import {
  validateVendorRegistration,
  vendorInquiryPayload,
} from '../helpers/inquiries'

export function useVendorRegistrationForm(): UseInquiryFormResult<VendorRegistrationForm> {
  const [form, setForm] = useState<VendorRegistrationForm>(EMPTY_VENDOR_REGISTRATION)
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState<string | null>(null)

  function update(patch: Partial<VendorRegistrationForm>) {
    setForm((current) => ({ ...current, ...patch }))
  }

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const message = validateVendorRegistration(form)
    if (message) {
      setError(message)
      return
    }
    setSubmitting(true)
    setError(null)
    try {
      await submitVendorInquiry(vendorInquiryPayload(form))
      setSubmitted(true)
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : VENDOR_REGISTRATION_COPY.error,
      )
    } finally {
      setSubmitting(false)
    }
  }

  return { form, update, submitting, submitted, error, onSubmit }
}
